{
  "build": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "BUILD_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "BUILD_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_FIXTURES_PASSWORD": "BUILD_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "NV_API_ORIGIN": "https://nv-student-api-build.herokuapp.com",
      "AUTH0_HOSTNAME": "nv-student-api-build.auth0.com",
      "AUTH0_CLIENT_ID": "DqnuN2jEiCqAfSJYi7L7esLtVgZ3Zmq2",
      "TABLEAU_ORIGIN": "https://awstest.newvisions.org",
      "HEROKU_APP_NAME": "nv-student-api-build",
      "PUSHER_KEY": "847943ec960f8b236bef",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": false,
      "GOOG_ANALTICS4_ID": null,
      "NEW_RELIC_APPLICATION_ID": "",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy"
    }
  },
  "local": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "no firebase for local",
      "NV_API_ORIGIN": "http://localhost:4000",
      "NV_API_DOMAIN": "localhost",
      "AUTH0_HOSTNAME": "nv-student-api-dev.auth0.com",
      "AUTH0_CLIENT_ID": "EskNv3wUaxVziGmx35j5PkWqzJXPEML0",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "TABLEAU_ORIGIN": "https://awstest.newvisions.org",
      "HEROKU_APP_NAME": "no-local-heroku-app",
      "PUSHER_KEY": "7ed107e3b478ca76516c",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": true,
      "GOOG_ANALTICS4_ID": "G-8FZ0303X98",
      "DISPLAY_NV_ENV": "LOCAL",
      "APP_ORIGIN": "http://localhost:3000",
      "NEW_RELIC_APPLICATION_ID": "",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "lansing-local": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "no firebase for local",
      "NV_API_ORIGIN": "http://localhost:4000",
      "NV_API_DOMAIN": "localhost",
      "AUTH0_HOSTNAME": "nv-student-api-dev.auth0.com",
      "AUTH0_CLIENT_ID": "JFwlNDiGEWvj7682iYO8L9SOBXEoPbMI",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "PUSHER_KEY": "847943ec960f8b236bef",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": true,
      "DISPLAY_NV_ENV": "LOCAL",
      "NEW_RELIC_APPLICATION_ID": "",
      "INTERCOM_APP_ID": "ny772og1",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "dev": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_RULE_NV_TOKEN": "DEV_AUTH0_RULE_NV_TOKEN",
      "AUTH0_RULE_M2M_CLIENT_ID": "DEV_AUTH0_RULE_M2M_CLIENT_ID",
      "AUTH0_RULE_M2M_CLIENT_SECRET": "DEV_AUTH0_RULE_M2M_CLIENT_SECRET",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-sandbox",
      "NV_API_ORIGIN": "https://nv-student-api-dev.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-dev.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-dev.auth0.com",
      "AUTH0_CLIENT_ID": "EskNv3wUaxVziGmx35j5PkWqzJXPEML0",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "TABLEAU_ORIGIN": "https://awstest.newvisions.org",
      "HEROKU_APP_NAME": "nv-student-api-dev",
      "PUSHER_KEY": "847943ec960f8b236bef",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": true,
      "GOOG_ANALTICS4_ID": "G-8FZ0303X98",
      "ROLLBAR_ENV": "nv-portal-sandbox",
      "APP_ORIGIN": "https://nv-portal-sandbox.firebaseapp.com",
      "DISPLAY_NV_ENV": "DEV",
      "DISPLAY_ENV_PATH": "dev",
      "NEW_RELIC_APPLICATION_ID": "723413554",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "dev2": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_RULE_NV_TOKEN": "DEV_AUTH0_RULE_NV_TOKEN",
      "AUTH0_RULE_M2M_CLIENT_ID": "DEV_AUTH0_RULE_M2M_CLIENT_ID",
      "AUTH0_RULE_M2M_CLIENT_SECRET": "DEV_AUTH0_RULE_M2M_CLIENT_SECRET",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-sandbox-2",
      "NV_API_ORIGIN": "https://nv-student-api-dev2.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-dev2.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-dev.auth0.com",
      "AUTH0_CLIENT_ID": "EskNv3wUaxVziGmx35j5PkWqzJXPEML0",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "TABLEAU_ORIGIN": "https://awstest.newvisions.org",
      "HEROKU_APP_NAME": "nv-student-api-dev",
      "PUSHER_KEY": "847943ec960f8b236bef",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": true,
      "GOOG_ANALTICS4_ID": "G-8FZ0303X98",
      "ROLLBAR_ENV": "nv-portal-sandbox-2",
      "APP_ORIGIN": "https://nv-portal-sandbox-2.firebaseapp.com",
      "DISPLAY_NV_ENV": "DEV2",
      "DISPLAY_ENV_PATH": "dev",
      "NEW_RELIC_APPLICATION_ID": "723411838",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "infra": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_RULE_NV_TOKEN": "DEV_AUTH0_RULE_NV_TOKEN",
      "AUTH0_RULE_M2M_CLIENT_ID": "DEV_AUTH0_RULE_M2M_CLIENT_ID",
      "AUTH0_RULE_M2M_CLIENT_SECRET": "DEV_AUTH0_RULE_M2M_CLIENT_SECRET",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-infra",
      "NV_API_ORIGIN": "https://nv-student-api-infrastructure.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-infrastructure.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-dev.auth0.com",
      "AUTH0_CLIENT_ID": "MNdCFVYFxApGFltFBr2XeKPe9roL1qC0",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "TABLEAU_ORIGIN": "https://awstest.newvisions.org",
      "HEROKU_APP_NAME": "nv-student-api-infra",
      "PUSHER_KEY": "a603d17ee9140d235f18",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": true,
      "GOOG_ANALTICS4_ID": "G-8FZ0303X98",
      "ROLLBAR_ENV": "nv-portal-infra",
      "APP_ORIGIN": "https://nv-portal-infra-2.firebaseapp.com",
      "DISPLAY_NV_ENV": "INFRA2",
      "DISPLAY_ENV_PATH": "INFRA",
      "NEW_RELIC_APPLICATION_ID": "",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "infra2": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_RULE_NV_TOKEN": "DEV_AUTH0_RULE_NV_TOKEN",
      "AUTH0_RULE_M2M_CLIENT_ID": "DEV_AUTH0_RULE_M2M_CLIENT_ID",
      "AUTH0_RULE_M2M_CLIENT_SECRET": "DEV_AUTH0_RULE_M2M_CLIENT_SECRET",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-infra-2",
      "NV_API_ORIGIN": "https://nv-student-api-infrastructure.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-infrastructure.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-dev.auth0.com",
      "AUTH0_CLIENT_ID": "MNdCFVYFxApGFltFBr2XeKPe9roL1qC0",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "TABLEAU_ORIGIN": "https://awstest.newvisions.org",
      "HEROKU_APP_NAME": "",
      "PUSHER_KEY": "a603d17ee9140d235f18",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": true,
      "GOOG_ANALTICS4_ID": "G-8FZ0303X98",
      "ROLLBAR_ENV": "nv-portal-infra-2",
      "APP_ORIGIN": "https://nv-portal-infra.firebaseapp.com",
      "DISPLAY_NV_ENV": "INFRA",
      "DISPLAY_ENV_PATH": "INFRA",
      "NEW_RELIC_APPLICATION_ID": "",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "qa": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_RULE_NV_TOKEN": "QA_AUTH0_RULE_NV_TOKEN",
      "AUTH0_RULE_M2M_CLIENT_ID": "QA_AUTH0_RULE_M2M_CLIENT_ID",
      "AUTH0_RULE_M2M_CLIENT_SECRET": "QA_AUTH0_RULE_M2M_CLIENT_SECRET",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-qa",
      "NV_API_ORIGIN": "https://nv-student-api-qa3.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-qa3.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-qa.auth0.com",
      "AUTH0_CLIENT_ID": "fqZD1448K82QscSC7FhCD0pHu5kxweWe",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "HEROKU_APP_NAME": "nv-student-api-qa",
      "PUSHER_KEY": "847943ec960f8b236bef",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": false,
      "GOOG_ANALTICS4_ID": "G-4F1ZE850BX",
      "ROLLBAR_ENV": "nv-portal-qa",
      "APP_ORIGIN": "https://nv-portal-qa.firebaseapp.com",
      "DISPLAY_NV_ENV": "QA",
      "DISPLAY_ENV_PATH": "qa",
      "NEW_RELIC_APPLICATION_ID": "",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "bear": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-bear",
      "NV_API_ORIGIN": "https://nv-student-api-qa3.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-qa3.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-qa.auth0.com",
      "AUTH0_CLIENT_ID": "fqZD1448K82QscSC7FhCD0pHu5kxweWe",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "HEROKU_APP_NAME": "nv-student-api-qa",
      "PUSHER_KEY": "847943ec960f8b236bef",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": false,
      "GOOG_ANALTICS4_ID": "G-4F1ZE850BX",
      "ROLLBAR_ENV": "nv-portal-bear",
      "APP_ORIGIN": "https://nv-portal-bear.firebaseapp.com",
      "DISPLAY_NV_ENV": "BEAR",
      "DISPLAY_ENV_PATH": "qa",
      "NEW_RELIC_APPLICATION_ID": "",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "lion": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-lion",
      "NV_API_ORIGIN": "https://nv-student-api-qa4.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-qa4.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-qa.auth0.com",
      "AUTH0_CLIENT_ID": "fqZD1448K82QscSC7FhCD0pHu5kxweWe",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "HEROKU_APP_NAME": "nv-student-api-qa",
      "PUSHER_KEY": "847943ec960f8b236bef",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": false,
      "GOOG_ANALTICS4_ID": "G-4F1ZE850BX",
      "ROLLBAR_ENV": "nv-portal-lion",
      "APP_ORIGIN": "https://nv-portal-lion.firebaseapp.com",
      "DISPLAY_NV_ENV": "LION",
      "DISPLAY_ENV_PATH": "qa",
      "NEW_RELIC_APPLICATION_ID": "",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "tiger": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-tiger",
      "NV_API_ORIGIN": "https://nv-student-api-uat.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-uat.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-qa.auth0.com",
      "AUTH0_CLIENT_ID": "fqZD1448K82QscSC7FhCD0pHu5kxweWe",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "HEROKU_APP_NAME": "nv-student-api-qa",
      "PUSHER_KEY": "847943ec960f8b236bef",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": false,
      "GOOG_ANALTICS4_ID": "G-4F1ZE850BX",
      "ROLLBAR_ENV": "nv-portal-tiger",
      "APP_ORIGIN": "https://nv-portal-tiger.firebaseapp.com",
      "DISPLAY_NV_ENV": "TIGER",
      "DISPLAY_ENV_PATH": "qa",
      "NEW_RELIC_APPLICATION_ID": "",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "eagle": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-eagle",
      "NV_API_ORIGIN": "https://nv-student-api-qa.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-qa.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-qa.auth0.com",
      "AUTH0_CLIENT_ID": "fqZD1448K82QscSC7FhCD0pHu5kxweWe",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "HEROKU_APP_NAME": "nv-student-api-qa",
      "PUSHER_KEY": "847943ec960f8b236bef",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": false,
      "GOOG_ANALTICS4_ID": "G-4F1ZE850BX",
      "ROLLBAR_ENV": "nv-portal-eagle",
      "APP_ORIGIN": "https://nv-portal-eagle.firebaseapp.com",
      "DISPLAY_NV_ENV": "EAGLE",
      "DISPLAY_ENV_PATH": "qa",
      "NEW_RELIC_APPLICATION_ID": "",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "squid": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-squid",
      "NV_API_ORIGIN": "https://nv-student-api-qa2.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-qa2.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-qa.auth0.com",
      "AUTH0_CLIENT_ID": "fqZD1448K82QscSC7FhCD0pHu5kxweWe",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "HEROKU_APP_NAME": "nv-student-api-qa",
      "PUSHER_KEY": "847943ec960f8b236bef",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": false,
      "GOOG_ANALTICS4_ID": "G-4F1ZE850BX",
      "ROLLBAR_ENV": "nv-portal-squid",
      "APP_ORIGIN": "https://nv-portal-squid.firebaseapp.com",
      "DISPLAY_NV_ENV": "SQUID",
      "DISPLAY_ENV_PATH": "qa",
      "NEW_RELIC_APPLICATION_ID": "",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "pig": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-pig",
      "NV_API_ORIGIN": "https://nv-student-api-qa5.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-qa5.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-qa.auth0.com",
      "AUTH0_CLIENT_ID": "fqZD1448K82QscSC7FhCD0pHu5kxweWe",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "HEROKU_APP_NAME": "nv-student-api-qa",
      "PUSHER_KEY": "847943ec960f8b236bef",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": false,
      "GOOG_ANALTICS4_ID": "G-4F1ZE850BX",
      "ROLLBAR_ENV": "nv-portal-pig",
      "APP_ORIGIN": "https://nv-portal-pig.firebaseapp.com",
      "DISPLAY_NV_ENV": "PIG",
      "DISPLAY_ENV_PATH": "qa",
      "NEW_RELIC_APPLICATION_ID": "",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "dolphin": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-dolphin",
      "NV_API_ORIGIN": "https://nv-student-api-qa6.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-qa6.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-qa.auth0.com",
      "AUTH0_CLIENT_ID": "fqZD1448K82QscSC7FhCD0pHu5kxweWe",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "HEROKU_APP_NAME": "nv-student-api-qa",
      "PUSHER_KEY": "847943ec960f8b236bef",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": false,
      "GOOG_ANALTICS4_ID": "G-4F1ZE850BX",
      "ROLLBAR_ENV": "nv-portal-dolphin",
      "APP_ORIGIN": "https://nv-portal-dolphin.firebaseapp.com",
      "DISPLAY_NV_ENV": "DOLPHIN",
      "DISPLAY_ENV_PATH": "qa",
      "NEW_RELIC_APPLICATION_ID": "",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "penguin": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "DEV_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "DEV_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_FIXTURES_PASSWORD": "DEV_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-penguin",
      "NV_API_ORIGIN": "https://nv-student-api-qa7.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-qa7.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-qa.auth0.com",
      "AUTH0_CLIENT_ID": "fqZD1448K82QscSC7FhCD0pHu5kxweWe",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "HEROKU_APP_NAME": "nv-student-api-qa",
      "PUSHER_KEY": "847943ec960f8b236bef",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": false,
      "GOOG_ANALTICS4_ID": "G-4F1ZE850BX",
      "ROLLBAR_ENV": "nv-portal-penguin",
      "APP_ORIGIN": "https://nv-portal-penguin.firebaseapp.com",
      "DISPLAY_NV_ENV": "PENGUIN",
      "DISPLAY_ENV_PATH": "qa",
      "NEW_RELIC_APPLICATION_ID": "",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "staging": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "STAGING_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "STAGING_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_RULE_NV_TOKEN": "STAGING_AUTH0_RULE_NV_TOKEN",
      "AUTH0_RULE_M2M_CLIENT_ID": "STAG_AUTH0_RULE_M2M_CLIENT_ID",
      "AUTH0_RULE_M2M_CLIENT_SECRET": "STAG_AUTH0_RULE_M2M_CLIENT_SECRET"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-staging",
      "NV_API_ORIGIN": "https://nv-student-api-staging.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-staging.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-staging.auth0.com",
      "AUTH0_CLIENT_ID": "JuCJKgc1vOdLLBDJJzNcelhDJGY7ja9P",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "TABLEAU_ORIGIN": "https://awstest.newvisions.org",
      "HEROKU_APP_NAME": "nv-student-api-staging",
      "PUSHER_KEY": "be21698038f3491807a8",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": false,
      "GOOG_ANALTICS4_ID": "G-BMB3X9CMZW",
      "ROLLBAR_ENV": "nv-portal-staging",
      "ROLLBAR_POST_CLIENT_ITEM": "2aefcf5e6d02445ea4a953f33793f947",
      "APP_ORIGIN": "https://nv-portal-staging.firebaseapp.com",
      "DISPLAY_NV_ENV": "STAGING",
      "DISPLAY_ENV_PATH": "staging",
      "NEW_RELIC_APPLICATION_ID": "723768804",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "stagingNoRollbar": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "STAGING_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "STAGING_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_RULE_NV_TOKEN": "STAGING_AUTH0_RULE_NV_TOKEN",
      "AUTH0_RULE_M2M_CLIENT_ID": "STAG_AUTH0_RULE_M2M_CLIENT_ID",
      "AUTH0_RULE_M2M_CLIENT_SECRET": "STAG_AUTH0_RULE_M2M_CLIENT_SECRET"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-staging",
      "NV_API_ORIGIN": "https://nv-student-api-staging.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-staging.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-staging.auth0.com",
      "AUTH0_CLIENT_ID": "JuCJKgc1vOdLLBDJJzNcelhDJGY7ja9P",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "TABLEAU_ORIGIN": "https://awstest.newvisions.org",
      "HEROKU_APP_NAME": "nv-student-api-staging",
      "PUSHER_KEY": "be21698038f3491807a8",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": false,
      "GOOG_ANALTICS4_ID": "G-BMB3X9CMZW",
      "ROLLBAR_ENV": "",
      "ROLLBAR_POST_CLIENT_ITEM": "",
      "APP_ORIGIN": "https://nv-portal-staging.firebaseapp.com",
      "DISPLAY_NV_ENV": "STAGING",
      "NEW_RELIC_APPLICATION_ID": "",
      "INTERCOM_APP_ID": "p7hxvqr5",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "7526dea2c4d00f1465f019d5e8a5b155"
    }
  },
  "prod": {
    "PrivateConfig": {
      "AUTH0_ADMIN_TOKEN": "PROD_AUTH0_ADMIN_TOKEN",
      "AUTH0_DELETE_USER_TOKEN": "PROD_AUTH0_DELETE_USER_TOKEN",
      "AUTH0_RULE_NV_TOKEN": "PROD_AUTH0_RULE_NV_TOKEN",
      "AUTH0_RULE_M2M_CLIENT_ID": "PROD_AUTH0_RULE_M2M_CLIENT_ID",
      "AUTH0_RULE_M2M_CLIENT_SECRET": "PROD_AUTH0_RULE_M2M_CLIENT_SECRET",
      "AUTH0_FIXTURES_PASSWORD": "PROD_AUTH0_FIXTURES_PASSWORD"
    },
    "PublicConfig": {
      "FIREBASE": "nv-portal-production",
      "NV_API_ORIGIN": "https://nv-student-api-prod.sysdaar.org",
      "NV_API_DOMAIN": "nv-student-api-prod.sysdaar.org",
      "AUTH0_HOSTNAME": "nv-student-api-prod.auth0.com",
      "AUTH0_CLIENT_ID": "ihcNnBkz84vkBvssEQ7GVkSKYOzhvHEV",
      "AUTH0_NAMESPACE": "https://nvportal.org",
      "TABLEAU_ORIGIN": "https://tableau.newvisions.org",
      "TABLEAU_ENV": "PROD",
      "HEROKU_APP_NAME": "nv-student-api-prod",
      "PUSHER_KEY": "af240c6c8049c75cfbbd",
      "PUSHER_ENCRYPTION_ENABLED": true,
      "DEV_MODE": false,
      "GOOG_ANALTICS4_ID": "G-G80G7EN0EZ",
      "ROLLBAR_ENV": "nv-portal-production",
      "ROLLBAR_POST_CLIENT_ITEM": "2aefcf5e6d02445ea4a953f33793f947",
      "APP_ORIGIN": "https://portal.newvisions.org",
      "DISPLAY_NV_ENV": "",
      "DISPLAY_ENV_PATH": "prod",
      "NEW_RELIC_APPLICATION_ID": "723769668",
      "INTERCOM_APP_ID": "eelf1be4",
      "PRIVACY_POLICY": "https://www.newvisions.org/privacy-policy",
      "MIXPANEL_PROJECT_TOKEN": "377e415476e505d317e67f3dd88c50ce"
    }
  }
}
